const config = {
  BASE_URL: 'https://restaurant-api.dicoding.dev',
  DATABASE_NAME: 'restaurant-database',
  DATABABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'favorite-restaurant',
};

export default config;
